export const dashboardPages = {
  board: () => import('./pages/DashboardPage'),
};
export { TeamEditor } from './components/TeamDialog';
export { TEAM_ROLES } from './lib/board';
export { useClientTeamQuery, useSaveClientTeamMutation } from './api/tasksApi';
